export const flags = {
  CamDatabaseImport: 'cam-database-import',
  WorkOrderModule: 'work-order-module',
  WorkOrderModuleCamIntegration: 'work-order-module-cam-integration',
  ToolDataImportModule: 'tool-data-import-module',
  TestAccountEndpoints: 'test-account-endpoints',
  NpsCampaignActive: 'nps-campaign-active',
  AcceptLanguageHeader: 'accept-language-header',
  New2DViewerItemAssembly: 'new-2d-viewer-item-assembly',
  New2DViewerCatalog: 'new-2d-viewer-catalog',
  AssemblyBuilderV2: 'assembly-builder-v2',
  CuttingData: 'cutting-data',
} as const;

export type Flag = (typeof flags)[keyof typeof flags];
